module.exports = __webpack_public_path__ + "static/media/motor-chart.4b8bcb2d.png";